import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
const VueCookie = require('vue-cookie');

require('videojs-youtube');
import VueVideoPlayer from 'vue-video-player'
Vue.use(VueVideoPlayer)
Vue.use(VueCookie);

import axios from 'axios'
import VueAxios from 'vue-axios'
// http://rosatom.we-demonstrate.ru/local/tools/api.php
axios.defaults.baseURL = window.location.hostname=='localhost' ? 'https://atom75.ru/local/tools/api.php' : '/local/tools/api.php';
//axios.defaults.baseURL = window.location.hostname=='localhost' ? 'http://rosatom.we-demonstrate.ru/local/tools/api.php' : '/local/tools/api.php';
Vue.use(VueAxios, axios)


Vue.config.productionTip = false

import '@/assets/scss/main.scss'
import 'video.js/dist/video-js.css'
import 'objectFitPolyfill/dist/objectFitPolyfill.min'
import '@/assets/js/polyfill.js'
import '@/assets/js/smoothscroll.js'
import '@/assets/js/promise.polyfill.js'
import '@/assets/js/fetch.polyfill.js'

import Closer from '@/components/elements/Closer'
Vue.component('Closer', Closer)


import VuePlyr from 'vue-plyr'
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: false }
  },
  emit: ['ended']
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
